import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import { useHomeScope } from '../../hooks/useHomeScope';
import { usePhone } from '../../hooks/usePhone';
import { useProperties } from '../../queries/properties';
import { useProspects } from '../../queries/prospects';
import { useMaintenance } from '../../queries/maintenance';
import { columnOf } from '../../utils/prospects';
import { AaTheme, Btn, Seg, cx } from '../Todos/ui';
import { useSchedule } from '../Contacts/useSchedule';
import UnitDrawer from '../Property/UnitDrawer';
import LeasingBoard from './LeasingBoard';
import MaintenanceTab from './MaintenanceTab';
import PortfolioTab from './PortfolioTab';
import VacanciesTab from './VacanciesTab';
import { isVacant } from '../../utils/property';
import '../Todos/aa.css';
import '../../styles/mcc-pages.css';

const TABS = ['leasing', 'maintenance', 'portfolio', 'vacancies'];

export default function Pipelines() {
  const phone = usePhone();
  const { params } = useHomeScope();
  const [search, setSearch] = useSearchParams();
  const tab = TABS.includes(search.get('tab')) ? search.get('tab') : 'leasing';
  const setTab = (t) => setSearch((prev) => {
    const next = new URLSearchParams(prev);
    next.set('tab', t);
    return next;
  });

  const { rows: prospects } = useProspects();
  const { rows: units } = useProperties();
  const { data: maint } = useMaintenance(params);
  const [schedule, scheduleNode] = useSchedule();
  const [openUnitId, setOpenUnitId] = useState(null);
  const open = units.find((u) => u._id === openUnitId);

  const leasingCount = prospects.filter((p) => columnOf(p) && columnOf(p) !== 'won').length;
  const openTickets = (maint?.tickets || []).filter((t) => t.status !== 'Resolved').length;
  const vacantCount = units.filter(isVacant).length;

  return (
    <AaTheme>
      <div className={cx('aa', phone && 'ph')}>
        <div className="m-page">
          <div className="m-ptitle">
            <div className="grow">
              <h1>Pipelines</h1>
              <div className="m-sub">Leasing, maintenance, portfolio and vacancies</div>
            </div>
            <Btn sm icon={faCalendarPlus} onClick={() => schedule('tour', {})}>
              Schedule
            </Btn>
          </div>
          <div className="aa-types">
            <Seg
              items={[
                ['leasing', 'Leasing pipeline', null, leasingCount],
                ['maintenance', 'Maintenance', null, openTickets],
                ['portfolio', 'Portfolio'],
                ['vacancies', 'Vacancies', null, vacantCount]
              ]}
              value={tab}
              onChange={setTab}
              label="Pipelines section"
            />
          </div>
          {tab === 'leasing' ? (
            <LeasingBoard />
          ) : tab === 'maintenance' ? (
            <MaintenanceTab />
          ) : tab === 'portfolio' ? (
            <PortfolioTab units={units} phone={phone} onOpenUnit={(u) => setOpenUnitId(u._id)} />
          ) : (
            <VacanciesTab units={units} phone={phone} onOpenUnit={(u) => setOpenUnitId(u._id)} />
          )}
        </div>
      </div>
      {open && (
        <UnitDrawer
          unit={open}
          canManage={false}
          onSchedule={(kind, initial) => {
            setOpenUnitId(null);
            schedule(kind, initial);
          }}
          onClose={() => setOpenUnitId(null)}
        />
      )}
      {scheduleNode}
    </AaTheme>
  );
}
